var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Messages } from "../../../configuration/event-messages.constants";
import { EventAggregator } from "aurelia-event-aggregator";
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import moment from "moment";
import "../Eonasdan/bootstrap-datetimepicker@4.17.43.js";
import "../Eonasdan/moment-timezone/index.js";
import { DateExpressionParser } from "../../../configuration/date-expressions";
import { DateTimeHelper } from "../../../helpers/date-time-helper";
import { DateHelper } from "../../../utilities/date-helper";
import { MobileHelper } from "../../../helpers/mobile-helper";
import { StringUtilities } from "../../../utilities/strings";
var DatePicker = /** @class */ (function () {
    function DatePicker(eventAggrigator, element) {
        var _this = this;
        this.eventAggrigator = eventAggrigator;
        this.element = element;
        this.options = {
            widgetParent: "picker-container div",
            allowInputToggle: true
        };
        this.formateKey = "format";
        this.useCurrentKey = "useCurrent";
        this.showTodayButtonKey = "showTodayButton";
        this.changeEventKey = "dp.change";
        this.datePickerId = "DateTimePicker";
        this._fKey = "_f";
        this._dKey = "_d";
        this.keepInvalid = true;
        this.useStrict = true;
        this.showPickerButton = true;
        this.placeholder = "";
        this.setDefault = true;
        this.info = "";
        this.showClose = false;
        this.disabledDates = [];
        this.showClear = false;
        this.dateFormat = "DD/MM/YYYY HH:mm";
        this.defaultTime = "12:00:00";
        this.hide = function () {
            if (_this && _this.datePickerController) {
                var picker = $(_this.picker);
                if (picker) {
                    var controller = picker.data(_this.datePickerId);
                    if (controller) {
                        controller.hide();
                    }
                }
            }
        };
        this.isEnabled = function (granularity) {
            if (typeof granularity !== 'string' || granularity.length > 1) {
                throw new TypeError('isEnabled expects a single character string parameter');
            }
            switch (granularity) {
                case 'y':
                    return _this.dateFormat.indexOf('Y') !== -1;
                case 'M':
                    return _this.dateFormat.indexOf('M') !== -1;
                case 'd':
                    return _this.dateFormat.toLowerCase().indexOf('d') !== -1;
                case 'h':
                case 'H':
                    return _this.dateFormat.toLowerCase().indexOf('h') !== -1;
                case 'm':
                    return _this.dateFormat.indexOf('m') !== -1;
                case 's':
                    return _this.dateFormat.indexOf('s') !== -1;
                default:
                    return false;
            }
        };
        this.hasTime = function () {
            return (_this.isEnabled('h') || _this.isEnabled('m') || _this.isEnabled('s'));
        };
        this.hasDate = function () {
            return (_this.isEnabled('y') || _this.isEnabled('M') || _this.isEnabled('d'));
        };
        this.subscriptionToDocumentClickEvent = this.eventAggrigator.subscribe(Messages.documentClick, this.hide);
    }
    Object.defineProperty(DatePicker.prototype, "picker", {
        get: function () {
            return this._picker;
        },
        set: function (value) {
            this._picker = value;
            if (value) {
                this.dateChanged(this.date, null);
            }
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.momentFormat = function (date) {
        if (this.timezone)
            return moment(date).tz(this.timezone).format(this.dateFormat);
        return moment(date).format(this.dateFormat);
    };
    DatePicker.prototype.attached = function () {
        var _this = this;
        this.isAttached = true;
        this.readOnlyValue = (this.date && !DateExpressionParser.isValidExpression(this.date ? this.date.toString() : null)) ? this.momentFormat(this.date) : this.date;
        if (this.options[this.formateKey] === undefined) {
            this.options[this.formateKey] = this.dateFormat ? this.dateFormat : "DD/MM/YYYY";
        }
        this.options[this.showTodayButtonKey] = true;
        if (this.timezone)
            this.options["timeZone"] = this.timezone;
        this.options["keepInvalid"] = this.keepInvalid;
        this.options["useStrict"] = this.useStrict;
        this.options["showClose"] = this.showClose;
        this.options["showClear"] = this.showClear;
        // this.options["debug"] = false;
        this.options[this.useCurrentKey] = false;
        var picker = $(this.picker);
        if (picker.datetimepicker) {
            this.datePickerController = picker.datetimepicker(this.options);
            var self_1 = this;
            picker.data(this.datePickerId).disabledDates(this.disabledDates);
            this.minDateChanged();
            this.maxDateChanged();
            this.disabledDatesChanged();
            this.datePickerController.on("dp.show", function (ev) { self_1.isVisible = true; });
            this.datePickerController.on("dp.hide", function (ev) {
                var pickerValue = _this.picker.value;
                if (MobileHelper.isMobileDevice()) {
                    _this.picker.removeAttribute('readonly');
                }
                _this.eventAggrigator.publish("hide-date-picker");
                self_1.isVisible = false;
                // commented since these where conflicting with timezone and the event below this one
                if (!_this.timezone) {
                    if (pickerValue && DateExpressionParser.isValidExpression(pickerValue)) {
                        _this.date = pickerValue;
                    }
                    else if (pickerValue && moment(pickerValue, _this.dateFormat, true).isValid()) {
                        if (_this.momentFormat(pickerValue) != _this.momentFormat(self_1.date)) {
                            var val = moment(pickerValue, _this.dateFormat, true).toDate();
                            if (!self_1.setDate(val)) {
                                self_1.date = val;
                            }
                        }
                    }
                }
            });
            this.datePickerController.on(this.changeEventKey, function (ev) {
                var newDate;
                if (ev.date === false) {
                    self_1.setDate(null);
                    return;
                }
                else if (ev.date[self_1._fKey] && StringUtilities.endsWith(ev.date[self_1._fKey], "Z") || ev.date._isUTC) {
                    newDate = moment(ev.date);
                }
                else {
                    newDate = moment(moment(ev.date[self_1._dKey]).format(self_1.dateFormat), self_1.dateFormat);
                }
                if (self_1.date != null && self_1.date !== undefined &&
                    self_1.date !== "" && newDate &&
                    ((typeof self_1.date === "object" && self_1.date.toJSON() !== newDate.toJSON()) ||
                        (typeof self_1.date === "string" && self_1.date !== newDate.toJSON()))) {
                    self_1.setDate(typeof self_1.date === "string" ? newDate.toJSON() : newDate.toDate());
                }
                else if (!self_1.date && _this.setDefault && !newDate) {
                    newDate = self_1.setDefaultTime(newDate);
                    self_1.setDate(typeof self_1.date === "string" ? newDate.toJSON() : newDate.toDate());
                }
                else if (newDate) {
                    self_1.setDate(typeof self_1.date === "string" ? newDate.toJSON() : newDate.toDate());
                }
                //this.hide();
            });
            var isDateExpression = DateExpressionParser.isValidExpression(this.date ? this.date.toString() : null);
            if (this.date && !isDateExpression) {
                this.setUiDate(this.date, null);
            }
            else if (this.date && isDateExpression) {
                this.picker.value = this.date.toString();
            }
        }
        this.intervalHandler = setInterval(function () {
            if (_this.isVisible) {
                var top_1 = $(_this.picker).offset().top;
                var left = $(_this.picker).offset().left;
                $("picker-container").css({ left: left + "px", top: top_1 + "px" });
            }
        }, 100);
    };
    DatePicker.prototype.detach = function () {
        clearInterval(this.intervalHandler);
    };
    DatePicker.prototype.setDefaultTime = function (date) {
        var arr = this.defaultTime.split(":");
        date = date.hour(Number(arr[0]));
        date = date.minute(Number(arr[1]));
        date = date.second(Number(arr[2]));
        return date;
    };
    DatePicker.prototype.openDatePicker = function (event) {
        if (this.datePickerController) {
            this.eventAggrigator.publish("show-date-picker");
            $(this.picker).data(this.datePickerId).show();
            if (event) {
                event.stopPropagation();
            }
            if (MobileHelper.isMobileDevice()) {
                this.picker.setAttribute('readonly', 'readonly');
            }
        }
    };
    DatePicker.prototype.timezoneChanged = function () {
        if (this.datePickerController) {
            var picker = $(this.picker).data(this.datePickerId);
            if (!picker) {
                return;
            }
            picker.timeZone(this.timezone);
        }
    };
    DatePicker.prototype.minDateChanged = function () {
        if (this.datePickerController) {
            var picker = $(this.picker).data(this.datePickerId);
            if (!picker) {
                return;
            }
            picker.minDate(this.minDate ? moment(this.hasTime() ? this.minDate : moment(this.getDate(this.minDate)).startOf('day')) : false);
        }
    };
    DatePicker.prototype.disabledDatesChanged = function () {
        var _this = this;
        if (this.datePickerController && this.disabledDates && this.disabledDates.length > 0) {
            $(this.picker).data(this.datePickerId).disabledDates(this.disabledDates.map(function (x) { return _this.momentFormat(_this.getDate(x)); }));
            var disabledDates = $(this.picker).data(this.datePickerId).disabledDates();
            var momentDate = moment(this.date);
            if (disabledDates[moment(this.date).format('YYYY-MM-DD')] === true) {
                while (disabledDates[momentDate.format('YYYY-MM-DD')] === true) {
                    momentDate = momentDate.add('days', 1);
                }
                this.setDate(momentDate.toDate());
            }
        }
    };
    DatePicker.prototype.maxDateChanged = function () {
        if (this.datePickerController) {
            var pickerId = $(this.picker).data(this.datePickerId);
            if (pickerId) {
                pickerId.maxDate(this.maxDate ? moment(this.maxDate) : false);
            }
        }
    };
    DatePicker.prototype.dateChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue == oldValue) {
            return;
        }
        if (!this.isAttached || !this.picker) {
            return;
        }
        var isDateExpression = DateExpressionParser.isValidExpression(this.date ? this.date.toString() : null);
        if (this.date && isDateExpression) {
            return;
        }
        if (newValue && oldValue) {
            if (this.date && isDateExpression) {
                return;
            }
            var date1 = this.momentFormat(newValue);
            var date2 = this.momentFormat(oldValue);
            if (moment.isMoment(oldValue) == moment.isMoment(newValue) &&
                date1 == date2 &&
                this.picker.value == date1 &&
                (!this.hasTime() || !this.hasDate())) {
                this.readOnlyValue = date1 ? date1 : null;
                return;
            }
        }
        if (this.datePickerController && !this.timezone && this.setDefault) {
            this.setUiDate(newValue, oldValue);
            this.setDefault = false;
        }
        setTimeout(function () {
            var paramsEvent = { detail: {}, bubbles: true };
            var changeDateEvent = new CustomEvent("date-changed", paramsEvent);
            _this.element.dispatchEvent(changeDateEvent);
        });
    };
    DatePicker.prototype.setUiDate = function (newValue, oldValue) {
        $(this.picker).data(this.datePickerId).date(newValue ? this.getDate(newValue) : null);
        this.readOnlyValue = newValue ? this.momentFormat(this.getDate(newValue)) : null;
        if (newValue !== null && !oldValue && this.minDate) {
            $(this.picker).data(this.datePickerId).minDate(this.getDate(this.minDate));
        }
    };
    DatePicker.prototype.setDate = function (val) {
        try {
            if (!this.date || !val || DateHelper.castDate(this.date).getTime() != DateHelper.castDate(val).getTime()
                || DateHelper.castDate(this.date).getDate() != DateHelper.castDate(this.date).getDate())
                this.date = this.getDate(val);
            return true;
        }
        catch (ex) {
            return false;
        }
    };
    DatePicker.prototype.getDate = function (val) {
        // make date equivalent in utc
        if (val && !this.hasTime()) {
            var dateString = DateTimeHelper.getDateString(DateHelper.castDate(val));
            if (dateString != moment(val).toJSON().split("T")[0]) {
                if (val instanceof Date) {
                    val.setMinutes(val.getTimezoneOffset() * -1);
                    return val;
                }
                else {
                    var momentDate = moment(val);
                    val = momentDate.add("minute", Math.abs(momentDate.utcOffset()));
                    return val.toDate();
                }
            }
        }
        return moment(val).toDate();
    };
    DatePicker.prototype.dateFormatChanged = function (newValue, oldValue) {
        if (!this.isAttached) {
            return;
        }
        ;
        this.options[this.formateKey] = newValue;
        this.datePickerController.update();
        this.disabledDatesChanged();
    };
    DatePicker.prototype.detached = function () {
        if (this.subscriptionToDocumentClickEvent) {
            this.subscriptionToDocumentClickEvent.dispose();
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "keepInvalid", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "useStrict", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DatePicker.prototype, "tab", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DatePicker.prototype, "date", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DatePicker.prototype, "minDate", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DatePicker.prototype, "maxDate", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "showPickerButton", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DatePicker.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "setDefault", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DatePicker.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DatePicker.prototype, "timezone", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DatePicker.prototype, "info", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "showClose", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], DatePicker.prototype, "disabledDates", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "showClear", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DatePicker.prototype, "dateFormat", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DatePicker.prototype, "defaultTime", void 0);
    DatePicker = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EventAggregator, Element])
    ], DatePicker);
    return DatePicker;
}());
export { DatePicker };
